import Autoconfiguration from "./Autoconfiguration";

export default Autoconfiguration;
